function fileSize (bytes: number, binary: boolean = true)
{
    const base = binary ? 1024 : 1000;

    bytes = Math.max(bytes, 0);

    let units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let pow   = Math.floor((bytes ? Math.log(bytes) : 0) / Math.log(base));

    pow = Math.min(pow, units.length - 1);
    bytes /= Math.pow(base, pow);

    return ('' + bytes.toFixed(2).replace(/./g, function(char, index, bytes)
    {
        return index && char !== '.' && ((bytes.length - index) % 3 === 0) ? '.' + char : (char === '.' ? ',' : char);
    })) + ' ' + units[pow];
}

export default fileSize;